module.exports = __webpack_public_path__ + "static/price_of_loyalty_mtg_afr-1508392e3c8f19ceb5d9d21babe981d8.webp";